export default "__VITE_ASSET__DMJ9MAkE__"